/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * RA cancel MH request payload
 * @export
 * @interface RaCancelMhRequest
 */
export interface RaCancelMhRequest {
    /**
     * 
     * @type {number}
     * @memberof RaCancelMhRequest
     */
    invoiceId?: number;
}

/**
 * Check if a given object implements the RaCancelMhRequest interface.
 */
export function instanceOfRaCancelMhRequest(value: object): value is RaCancelMhRequest {
    return true;
}

export function RaCancelMhRequestFromJSON(json: any): RaCancelMhRequest {
    return RaCancelMhRequestFromJSONTyped(json, false);
}

export function RaCancelMhRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RaCancelMhRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'invoiceId': json['invoiceId'] == null ? undefined : json['invoiceId'],
    };
}

export function RaCancelMhRequestToJSON(json: any): RaCancelMhRequest {
    return RaCancelMhRequestToJSONTyped(json, false);
}

export function RaCancelMhRequestToJSONTyped(value?: RaCancelMhRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoiceId': value['invoiceId'],
    };
}

